<template>
<div>
    <top-head></top-head>
    <doubleCarousel></doubleCarousel>
</div>
</template>
<script>
import topHead from '@/components/parts/headPart';
import pageFoot from '@/components/parts/pageFoot.vue'
import doubleCarousel from '@/components/parts/doubleCarousel'

export default {
    name: 'gamePage',
    components: { doubleCarousel, topHead, pageFoot },
    data() {
        return {

        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/gameNew.vue